import { episodesActionTypes } from '@/admin/pages/studyGoBridgeEpisodes/Constants';

import type { Episode } from '@/admin/pages/studyGoBridgeEpisodes/types';

export interface GetEpisodesRequestAction {
	type: typeof episodesActionTypes.GET_EPISODES_REQUEST;
}

export interface GetEpisodesSuccessAction {
	type: typeof episodesActionTypes.GET_EPISODES_SUCCESS;
	payload: {
		episodes: Episode[];
	};
}

export interface GetEpisodesErrorAction {
	type: typeof episodesActionTypes.GET_EPISODES_ERROR;
	payload: {
		error: string;
	};
}

export type EpisodesActions =
	| GetEpisodesRequestAction
	| GetEpisodesSuccessAction
	| GetEpisodesErrorAction;

export function getEpisodesRequest(): GetEpisodesRequestAction {
	return {
		type: episodesActionTypes.GET_EPISODES_REQUEST,
	};
}

export function getEpisodesSuccess(data: { episodes: Episode[] }): GetEpisodesSuccessAction {
	return {
		type: episodesActionTypes.GET_EPISODES_SUCCESS,
		payload: data,
	};
}

export function getEpisodesError(error: string): GetEpisodesErrorAction {
	return {
		type: episodesActionTypes.GET_EPISODES_ERROR,
		payload: { error },
	};
}
